<template>
<div class="chapter">
<div class="inner_page">
<p class="parttitle" id="pt1"><span><a id="page_7"></a><a href="#/Contents#rpt1">Part I</a></span></p>
<p class="parttitlea"><span><a href="#/Contents#rpt1">BEFORE YOU BEGIN</a></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Part001.vue?53d3aa88